export const SUPPORT_LINK = 'https://support.calm.com/hc/en-us/requests/new';
